import { IconID } from '@thoughtspot/radiant-react/widgets/icon';
import { SpotlightItemType } from './spotlight.types';
export const SPOTLIGHT_ROUTE_CONFIG = {
    Home: {
        label: 'Home',
        description: 'Go to home page',
        icon: IconID.THOUGHTSPOT,
        keywords: ['dashboard', 'start', 'main', 'landing'],
        category: 'navigation',
    },
    StratusHome: {
        label: 'Home',
        description: 'Go to home page',
        icon: IconID.THOUGHTSPOT,
        keywords: ['dashboard', 'start', 'main', 'landing'],
        category: 'navigation',
    },
    StratusHomeReact: {
        label: 'Insights Home',
        description: 'View insights and analytics',
        icon: IconID.LIGHTNING,
        keywords: ['insights', 'analytics', 'discover'],
        category: 'navigation',
    },
    Insights: {
        label: 'Insights',
        description: 'View insights and analytics',
        icon: IconID.LIGHTNING,
        keywords: ['insights', 'analytics', 'discover'],
        category: 'navigation',
    },
    HomeAnswers: {
        label: 'My Answers',
        description: 'View your saved answers',
        icon: IconID.ANSWER,
        keywords: ['answers', 'saved', 'queries'],
        category: 'navigation',
    },
    HomeLiveboards: {
        label: 'My Liveboards',
        description: 'View your liveboards',
        icon: IconID.LIVEBOARD_V2,
        keywords: ['liveboards', 'dashboards', 'pinboards'],
        category: 'navigation',
    },
    HomeFavs: {
        label: 'Favorites',
        description: 'View your favorite items',
        icon: IconID.STAR,
        keywords: ['favorites', 'starred', 'bookmarks'],
        category: 'navigation',
    },
    HomeCreatedByMe: {
        label: 'Created by Me',
        description: 'View items you created',
        icon: IconID.ADD_USER,
        keywords: ['my content', 'owned', 'created'],
        category: 'navigation',
    },
    HomeSpotIQAnalysis: {
        label: 'SpotIQ Analysis',
        description: 'View AI-powered insights',
        icon: IconID.CHART_SPOTIQ_ANOMALY_LESS,
        keywords: ['spotiq', 'ai', 'insights', 'analysis'],
        category: 'navigation',
    },
    HomeMonitorAlerts: {
        label: 'Monitor Alerts',
        description: 'View your alerts',
        icon: IconID.BELL_UNDO,
        keywords: ['alerts', 'monitor', 'notifications'],
        category: 'navigation',
    },
    Answers: {
        label: 'All Answers',
        description: 'Browse all answers',
        icon: IconID.ANSWER,
        keywords: ['answers', 'search', 'queries', 'all'],
        category: 'navigation',
    },
    Pinboards: {
        label: 'All Liveboards',
        description: 'Browse all liveboards',
        icon: IconID.LIVEBOARD_V2,
        keywords: ['liveboards', 'dashboards', 'pinboards', 'all'],
        category: 'navigation',
    },
    MonitorV2: {
        label: 'Monitor',
        description: 'View alerts and subscriptions',
        icon: IconID.BELL_UNDO,
        keywords: ['monitor', 'alerts', 'subscriptions', 'notifications'],
        category: 'navigation',
    },
    PinboardScheduledReports: {
        label: 'Schedules',
        description: 'Manage scheduled reports',
        icon: IconID.CALENDAR,
        keywords: ['schedules', 'reports', 'scheduled', 'recurring'],
        category: 'navigation',
    },
    ManageSchedulesV2: {
        label: 'Manage Schedules',
        description: 'Manage all schedules',
        icon: IconID.CALENDAR,
        keywords: ['schedules', 'manage', 'reports'],
        category: 'navigation',
    },
    Data: {
        label: 'Data',
        description: 'Manage data sources',
        icon: IconID.TABLE,
        keywords: ['data', 'sources', 'tables', 'database'],
        category: 'data',
    },
    Tables: {
        label: 'Tables',
        description: 'View and manage tables',
        icon: IconID.TABLE,
        keywords: ['tables', 'data', 'database'],
        category: 'data',
    },
    Views: {
        label: 'Views',
        description: 'View and manage views',
        icon: IconID.TABLE,
        keywords: ['views', 'data'],
        category: 'data',
    },
    Worksheet: {
        label: 'Worksheets',
        description: 'View and manage worksheets',
        icon: IconID.SAVE_WORKSHEET,
        keywords: ['worksheets', 'data model'],
        category: 'data',
    },
    Embrace: {
        label: 'Connections',
        description: 'Manage data connections',
        icon: IconID.CONNECTOR_WHITE,
        keywords: ['connections', 'embrace', 'database', 'sources'],
        category: 'data',
    },
    EmbraceConnection: {
        label: 'Connection Details',
        description: 'View connection details',
        icon: IconID.CONNECTOR_WHITE,
        keywords: ['connection', 'database'],
        category: 'data',
    },
    SpotApp: {
        label: 'SpotApps',
        description: 'Browse and manage SpotApps',
        icon: IconID.SPOTTER_TOOLS,
        keywords: ['spotapps', 'apps', 'templates'],
        category: 'data',
    },
    Dataset: {
        label: 'Datasets',
        description: 'View datasets',
        icon: IconID.TABLE,
        keywords: ['datasets', 'data'],
        category: 'data',
    },
    Dataflow: {
        label: 'Dataflow',
        description: 'Manage data flows',
        icon: IconID.TABLE,
        keywords: ['dataflow', 'etl', 'pipeline'],
        category: 'data',
    },
    SqlView: {
        label: 'SQL View',
        description: 'Create SQL views',
        icon: IconID.CODE,
        keywords: ['sql', 'view', 'query'],
        category: 'data',
    },
    DataExplorer: {
        label: 'Data Explorer',
        description: 'Explore your data',
        icon: IconID.SEARCH_V2,
        keywords: ['explore', 'data', 'browse'],
        category: 'data',
    },
    Dbt: {
        label: 'dbt',
        description: 'dbt integration',
        icon: IconID.CODE,
        keywords: ['dbt', 'integration', 'transform'],
        category: 'data',
    },
    CustomCalendarV2: {
        label: 'Custom Calendar',
        description: 'Manage custom calendars',
        icon: IconID.CALENDAR,
        keywords: ['calendar', 'custom', 'fiscal'],
        category: 'data',
    },
    Admin: {
        label: 'Admin Console',
        description: 'Administration settings',
        icon: IconID.AXIS_SETTINGS,
        keywords: ['admin', 'settings', 'configuration', 'management'],
        category: 'admin',
    },
    UserManagementUsers: {
        label: 'Users',
        description: 'Manage users',
        icon: IconID.ADD_USER,
        keywords: ['users', 'members', 'accounts', 'people'],
        category: 'admin',
    },
    UserManagementGroups: {
        label: 'Groups',
        description: 'Manage user groups',
        icon: IconID.GROUP,
        keywords: ['groups', 'teams', 'roles'],
        category: 'admin',
    },
    UserPreference: {
        label: 'Profile & Settings',
        description: 'Your profile and preferences',
        icon: IconID.TOOLTIP_SETTINGS,
        keywords: ['profile', 'settings', 'preferences', 'account'],
        category: 'admin',
    },
    Profile: {
        label: 'Profile',
        description: 'Your profile settings',
        icon: IconID.TOOLTIP_SETTINGS,
        keywords: ['profile', 'settings', 'account'],
        category: 'admin',
    },
    Teams: {
        label: 'Teams',
        description: 'Team settings',
        icon: IconID.GROUP,
        keywords: ['teams', 'organization'],
        category: 'admin',
    },
    TeamsMembers: {
        label: 'Team Members',
        description: 'Manage team members',
        icon: IconID.GROUP,
        keywords: ['members', 'team', 'people'],
        category: 'admin',
    },
    TeamsDataUsage: {
        label: 'Data Usage',
        description: 'View data usage statistics',
        icon: IconID.TABLE,
        keywords: ['usage', 'data', 'statistics'],
        category: 'admin',
    },
    OrgsHome: {
        label: 'Organizations',
        description: 'Manage organizations',
        icon: IconID.GROUP,
        keywords: ['orgs', 'organizations', 'tenants'],
        category: 'admin',
    },
    OrgsUsers: {
        label: 'Org Users',
        description: 'Manage organization users',
        icon: IconID.ADD_USER,
        keywords: ['users', 'org', 'members'],
        category: 'admin',
    },
    OrgsGroups: {
        label: 'Org Groups',
        description: 'Manage organization groups',
        icon: IconID.GROUP,
        keywords: ['groups', 'org', 'teams'],
        category: 'admin',
    },
    Develop: {
        label: 'Developer Portal',
        description: 'Embed and customize ThoughtSpot',
        icon: IconID.CODE,
        keywords: ['developer', 'embed', 'api', 'customize'],
        category: 'develop',
    },
    DevelopActionsCustomization: {
        label: 'Actions Customization',
        description: 'Customize actions',
        icon: IconID.CODE,
        keywords: ['actions', 'customize', 'developer'],
        category: 'develop',
    },
    ConvAssist: {
        label: 'Spotter',
        description: 'AI-powered conversational analytics',
        icon: IconID.CHART_SPOTIQ_ANOMALY_LESS,
        keywords: ['spotter', 'ai', 'conversation', 'chat', 'assistant'],
        category: 'navigation',
    },
    Eureka: {
        label: 'Search',
        description: 'Search your data',
        icon: IconID.SEARCH_V2,
        keywords: ['search', 'query', 'find', 'eureka'],
        category: 'navigation',
    },
    CreateAiAnswer: {
        label: 'AI Answer',
        description: 'Create AI-powered answer',
        icon: IconID.CHART_SPOTIQ_ANOMALY_LESS,
        keywords: ['ai', 'answer', 'create'],
        category: 'navigation',
    },
    SpotterChat: {
        label: 'Create Spotter chat',
        description: 'Start AI-powered conversation',
        icon: IconID.CHART_SPOTIQ_ANOMALY_LESS,
        keywords: ['new', 'create', 'spotter', 'ai', 'chat', 'conversation'],
        type: SpotlightItemType.ACTION,
        category: 'action',
    },
    Answer: {
        label: 'Create Answer',
        description: 'Start a new search query',
        icon: IconID.ADD_NOTE_OUTLINE,
        keywords: ['new', 'create', 'answer', 'search', 'query'],
        type: SpotlightItemType.ACTION,
        category: 'action',
    },
    Liveboard: {
        label: 'Create Liveboard',
        description: 'Create a new liveboard dashboard',
        icon: IconID.LIVEBOARD_V2,
        keywords: ['new', 'create', 'liveboard', 'dashboard', 'pinboard'],
        type: SpotlightItemType.ACTION,
        category: 'action',
    },
    Connection: {
        label: 'Create Connection',
        description: 'Connect to a data source',
        icon: IconID.CONNECTOR_WHITE,
        keywords: ['new', 'create', 'connection', 'data source', 'database'],
        type: SpotlightItemType.ACTION,
        category: 'action',
    },
    Collection: {
        label: 'Create Collection',
        description: 'Organize content in a collection',
        icon: IconID.COLLECTION,
        keywords: ['new', 'create', 'collection', 'folder', 'organize'],
        type: SpotlightItemType.ACTION,
        category: 'action',
    },
    AnswerEdit: {
        label: 'Edit Answer',
        description: 'Edit an existing answer',
        icon: IconID.PENCIL,
        keywords: ['edit', 'answer', 'modify'],
        type: SpotlightItemType.ACTION,
        category: 'action',
    },
    WorksheetCreate: {
        label: 'Create Worksheet',
        description: 'Create a new worksheet',
        icon: IconID.ADD_NOTE_OUTLINE,
        keywords: ['new', 'create', 'worksheet', 'data model'],
        type: SpotlightItemType.ACTION,
        category: 'action',
    },
    AutoWorksheet: {
        label: 'Auto Create Worksheet',
        description: 'Automatically create a worksheet',
        icon: IconID.ADD_NOTE_OUTLINE,
        keywords: ['auto', 'create', 'worksheet'],
        type: SpotlightItemType.ACTION,
        category: 'action',
    },
    AutoAnswer: {
        label: 'Auto Create Answer',
        description: 'Automatically create an answer',
        icon: IconID.ADD_NOTE_OUTLINE,
        keywords: ['auto', 'create', 'answer'],
        type: SpotlightItemType.ACTION,
        category: 'action',
    },
    ScheduleReport: {
        label: 'Create Schedule',
        description: 'Schedule a new report',
        icon: IconID.ADD_NOTE_OUTLINE,
        keywords: ['new', 'create', 'schedule', 'report'],
        type: SpotlightItemType.ACTION,
        category: 'action',
    },
    ImportCSV: {
        label: 'Import CSV',
        description: 'Import data from CSV file',
        icon: IconID.ADD_NOTE_OUTLINE,
        keywords: ['import', 'csv', 'upload', 'data'],
        type: SpotlightItemType.ACTION,
        category: 'action',
    },
    ImportData: {
        label: 'Import Data',
        description: 'Import data',
        icon: IconID.ADD_NOTE_OUTLINE,
        keywords: ['import', 'data', 'upload'],
        type: SpotlightItemType.ACTION,
        category: 'action',
    },
    ImportTsl: {
        label: 'Import TML',
        description: 'Import TML files',
        icon: IconID.ADD_NOTE_OUTLINE,
        keywords: ['import', 'tml', 'yaml'],
        type: SpotlightItemType.ACTION,
        category: 'action',
    },
    CreateSchema: {
        label: 'Create Schema',
        description: 'Create a new schema',
        icon: IconID.ADD_NOTE_OUTLINE,
        keywords: ['create', 'schema', 'database'],
        type: SpotlightItemType.ACTION,
        category: 'action',
    },
};
export const generateSpotlightItems = (routePaths, customConfig) => {
    const config = customConfig
        ? { ...SPOTLIGHT_ROUTE_CONFIG, ...customConfig }
        : SPOTLIGHT_ROUTE_CONFIG;
    const items = [];
    Object.entries(routePaths).forEach(([routeKey, path]) => {
        const routeConfig = config[routeKey];
        if (!routeConfig || routeConfig.hidden)
            return;
        if (path.includes(':') || path.includes('*'))
            return;
        items.push({
            id: `route-${routeKey}`,
            label: routeConfig.label,
            description: routeConfig.description,
            icon: routeConfig.icon,
            type: routeConfig.type || SpotlightItemType.NAVIGATION,
            path,
            keywords: routeConfig.keywords,
        });
    });
    return items;
};
export const getSpotlightItemsByCategory = (routePaths, customConfig) => {
    const items = generateSpotlightItems(routePaths, customConfig);
    const navigation = items.filter(item => item.type === SpotlightItemType.NAVIGATION);
    const actions = items.filter(item => item.type === SpotlightItemType.ACTION);
    return {
        navigation,
        actions,
        all: items,
    };
};
export const createRouteConfig = (key, config) => ({
    [key]: config,
});
export const createSpotlightItem = (id, path, config) => ({
    id: `custom-${id}`,
    label: config.label,
    description: config.description,
    icon: config.icon,
    type: config.type || SpotlightItemType.NAVIGATION,
    path,
    keywords: config.keywords,
});
export const generateSpotlightItemsFromRoutes = generateSpotlightItems;
//# sourceMappingURL=spotlight-routes.js.map